import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CategoryParams, MenuCategory } from 'models';

const initialState = {
  menuCategoryLoading: false,
  menuCategoryList: [] as Array<MenuCategory>,
  menuProductLoading: true,
  menuProductList: [],
  menuSetLoading: false,
  menuSetList: [],
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    getMenuCategoryList(state, action: PayloadAction<CategoryParams>) {
      state.menuCategoryLoading = true;
    },
    getMenuCategoryListSuccess(state, action: PayloadAction<Array<MenuCategory>>) {
      state.menuCategoryList = action.payload;
      state.menuCategoryLoading = false;
    },
    getMenuProductList(
      state,
      action: PayloadAction<{ shopId: number; type_get: string; appName: string }>
    ) {
      state.menuProductLoading = true;
    },
    getMenuProductListSuccess(state, action: PayloadAction<any>) {
      state.menuProductLoading = false;
      state.menuProductList = action.payload;
    },
    getMenuSetList(state, action: PayloadAction<{ shop_id: number; appName: string }>) {
      state.menuSetLoading = true;
    },
    getMenuSetListSuccess(state, action: PayloadAction<any>) {
      state.menuSetLoading = false;
      state.menuSetList = action.payload;
    },
  },
});

// Actions
export const menuAction = menuSlice.actions;

// Reducer
const menuReducer = menuSlice.reducer;
export default menuReducer;
